module.exports = __webpack_public_path__ + "fontawesome-webfont.acf3dcb7ff752b5296ca.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0
// module id = ../../../../../src/assets/fonts/font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0
// module chunks = styles